<template>
  <v-card>
    <v-card-title>
      <h2 class="card-title">{{ lang === 'uk' ? 'Навчальні матеріали' : 'Training materials' }}</h2>
    </v-card-title>

    <v-card-content>
      <div class="modal-layout">
        <div class="left-panel">
          <div class="onboarding-menu">
            <div v-for="(section, key) in onboardingData" :key="key" class="section-group">
              <div class="section-header" @click="toggleSection(key)" :class="{
                'active': expandedSections.includes(key)
              }">
                 <div class="section-header-content">
                  <svg v-if="section.icon" class="section-icon">
                    <use :xlink:href="`/svg/sprite.svg#${section.icon}`"></use>
                  </svg>
                  <div class="section-title">
                    {{ section.title }}
                  </div>
                </div>
                <span class="arrow" :class="{ 'expanded': expandedSections.includes(key) }"></span>
              </div>

              <div v-if="expandedSections.includes(key)" class="section-content">
                <div class="onboarding-items">
                  <v-btn v-for="item in section.onboardingItems" :key="item.id" class="onboarding-item-btn"
                    @click="showInIframe(item.link, item)" :class="{
                      'active-item': selectedItemId === item.id
                    }">
                    {{ item.text }}
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="right-panel">
          <div v-if="!selectedLink" class="placeholder">
            <p class="grey--text">Оберіть розділ для перегляду</p>
          </div>
          <div v-else class="iframe-container">
            <iframe ref="notionIframe" :src="selectedLink" class="notion-iframe" frameborder="0" allowfullscreen
              ></iframe>
          </div>
        </div>
      </div>
    </v-card-content>

  </v-card>
</template>

<script>
import sectionsData from '@/onboardingData/data.json'
import sectionsDataEN from '@/onboardingData/data-en.json'
import { mapGetters } from 'vuex'

export default {
  name: 'OnboardingNotionModal',

  props: {
    item: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      expandedSections: [],
      selectedLink: '',
      selectedItemId: null,
    }
  },

  computed: {
    ...mapGetters('onboarding', [
      'currentOnboardingNotionItem'
    ]),
    lang () {
      const language = this.$store.getters['account/lang']
      return language === 'us' ? 'en' : language
    },

    onboardingData () {
      return this.lang === 'uk' ? sectionsData : sectionsDataEN
    },

    activeItem () {
      const item = this.item || this.currentOnboardingNotionItem
      return item
    },

    currentSectionKey () {
      const currentRoute = this.$route.path
      if (currentRoute.includes('/planning') || currentRoute.includes('/kkz')) {
        return 'planning'
      }
      if (currentRoute.includes('/reports')) {
        return 'reports'
      }
      if (currentRoute.includes('/animal-groups')) {
        return 'animals'
      }
      if (currentRoute.includes('/stock')) {
        return 'warehouse'
      }
      if (currentRoute.includes('/rations')) {
        return 'rations'
      }
      if (currentRoute.includes('/history')) {
        return 'history'
      }
      if (currentRoute.includes('/admin/users')) {
        return 'users'
      }
      if (currentRoute.includes('/admin/groups')) {
        return 'access_groups'
      }
      if (currentRoute.includes('/admin/animal-types')) {
        return 'animal_types'
      }
      if (currentRoute.includes('/admin/ingredient-types')) {
        return 'ingredient_types'
      }
      if (currentRoute.includes('/admin/mixers')) {
        return 'mixers'
      }
      return 'general_settings'
    },

    isAdminRoute () {
      return this.$route.path.includes('/admin/')
    },

    mainMenuData () {
      // eslint-disable-next-line camelcase
      const { users, access_groups, animal_types, ingredient_types, mixers, ...mainData } = this.onboardingData
      return mainData
    },

    adminMenuData () {
      // eslint-disable-next-line camelcase
      const { users, access_groups, animal_types, ingredient_types, mixers } = this.onboardingData
      return { users, access_groups, animal_types, ingredient_types, mixers }
    },


  },

  mounted () {
    if (this.currentSectionKey && !this.expandedSections.includes(this.currentSectionKey)) {
      this.expandedSections.push(this.currentSectionKey)
    }

    if (this.activeItem && this.activeItem.link) {
      this.selectedLink = this.activeItem.link
      this.selectedItemId = this.activeItem.id
    }
    this.$nextTick(() => {
      this.scrollToActiveItem()
    })
  },

  watch: {
    item: {
      handler (newItem) {
        if (newItem && newItem.link) {
          this.selectedLink = newItem.link
          this.selectedItemId = newItem.id

          if (newItem.section && !this.expandedSections.includes(newItem.section)) {
            this.expandedSections.push(newItem.section)
          }
        }
      },
      immediate: true
    }
  },

  methods: {
    showInIframe (link, item) {
      this.selectedLink = link
      this.selectedItemId = item.id
      this.$nextTick(() => {
        this.scrollToActiveItem()
      })
    },
    toggleSection (key) {
      const index = this.expandedSections.indexOf(key)
      if (index > -1) {
        this.expandedSections.splice(index, 1)
      } else {
        this.expandedSections = [key]
        this.selectedItemId = null
      }
    },
    scrollToActiveItem () {
      const container = this.$el.querySelector('.left-panel')
      const activeEl = container.querySelector('.active-item')
      if (activeEl) {
        activeEl.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.modal-layout {
  display: flex;
  height: 60rem;
  gap: 1.6rem;
}

.left-panel {
  width: 28rem;
  border-right: 0.1rem solid #e0e0e0;
  padding-right: 1.6rem;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #59CC56 transparent;
  @media screen  and (max-width: 800px) {
    display: none;
  }

  &::-webkit-scrollbar {
    width: 0.6rem;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 0.3rem;
    border: 0.1rem solid transparent;
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: #555;
  }
}

.right-panel {
  flex: 1;
  position: relative;
  overflow: hidden;
}

.iframe-container {
  position: relative;
  height: calc(100% - -12rem);
  width: 100%;
}

.scroll-to-top-btn {
  position: absolute !important;
  bottom: 5rem !important;
  right: 1.6rem !important;
  z-index: 10 !important;
  background-color: #1DA643 !important;
  color: white !important;
  font-size: 1.8rem !important;
  font-weight: bold !important;
  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;

  &:hover {
    background-color: #15803d !important;
    transform: translateY(-0.2rem) !important;
    box-shadow: 0 0.6rem 1.2rem rgba(0, 0, 0, 0.4) !important;
  }
}

.placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
}

.notion-iframe {
  width: 100%;
  height: 100%;
  border-radius: 0.4rem;
  margin-top: -12rem;
}

.onboarding-menu {
  max-width: 100%;
}

.section-group {
  border-radius: 0.4rem;
  margin-bottom: 0.8rem;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 2rem;
  cursor: pointer;
  background-color: #fff;
  transition: background-color 0.2s;
  height: 5rem;
  border-radius: 1rem;

  &:hover {
    background-color: #EEEEEE;
  }

  &.active {
    background-color: #ddf2e3;
  }
}
.section-header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.section-icon {
  width: 2rem;
  height: 2rem;
  fill: #666;
  color: #666;
  transition: fill 0.2s ease;
  
  .section-header:hover & {
    fill: #333;
    color: #333;
  }

  .section-header.active & {
    fill: #1DA643;
    color: #1DA643;
   
  }
}
.section-title {
  font-weight: 600;
  font-size: 1.4rem;
}

.section-content {
  padding: 0.8rem;
}

.onboarding-items {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.onboarding-item-btn {
  justify-content: flex-start;
  text-align: left;
  padding-left: 1.2rem;
  width: 100%;
  font-size: 1.2rem;
  transition: background-color 0.2s;
  background-color: #fff;
  color: #000;

  &:hover {
    background-color: #eee;
  }

  &.active-item {
    background-color: #ddf2e3;
  }

  .v-btn__content {
    justify-content: flex-start;
  }
}

h3 {
  margin-bottom: 1.6rem;
  color: #424242;
}

.arrow {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  transition: transform 0.2s ease;
  user-select: none;
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 1rem;
    height: 0.7rem;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 7' fill='%23000' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.70711 0.792893C10.0976 1.18342 10.0976 1.81658 9.70711 2.20711L5 6.91421L0.292893 2.20711C-0.0976315 1.81658 -0.0976315 1.18342 0.292893 0.792893C0.683417 0.402369 1.31658 0.402369 1.70711 0.792893L5 4.08579L8.29289 0.792893C8.68342 0.402369 9.31658 0.402369 9.70711 0.792893Z'%3E%3C/path%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-size: contain;
  }

  &.expanded::before {
    transform: rotate(180deg);
  }
}

.section-header:hover .arrow::before,
.section-header.active .arrow::before {
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 7' fill='%23000' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M9.70711 0.792893C10.0976 1.18342 10.0976 1.81658 9.70711 2.20711L5 6.91421L0.292893 2.20711C-0.0976315 1.81658 -0.0976315 1.18342 0.292893 0.792893C0.683417 0.402369 1.31658 0.402369 1.70711 0.792893L5 4.08579L8.29289 0.792893C8.68342 0.402369 9.31658 0.402369 9.70711 0.792893Z'%3E%3C/path%3E%3C/svg%3E");
}
</style>